/* eslint-disable max-lines-per-function */
import React from "react";
import { SelectProps } from "@mui/material";
import { QueryInterestFormData } from "types/gql-types";
import { Button, DropDownButton } from "components/haven-design/buttons";
import Form from "../interests-form";

type Props = {
  formData: QueryInterestFormData["interest"];
  isSending: boolean;
  schema: NonNullable<NonNullable<QueryInterestFormData["applicationFormMetadata"]>["schema"]>;
  setSubmitBtnIndex: (index: number) => void;
  submitBtnIndex: number;
  onChangeHousehold: SelectProps["onChange"];
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onCancel: () => void;
}

const InterestUpdateContent: React.FC<Props> = (props) => {
  const updateEnabledForList =
    props.formData?.interestList.scheduledUpdate.enabled;
  const updateRequestInterests = props.formData?.updateRequestInterests || [];
  const requestIsActive = updateRequestInterests
    .some(({ updateRequest: { isActive } }) => isActive);
  const hasBeenResponded = updateRequestInterests.some(({ respondedAt }) => respondedAt);

  const isKeepOnListAvailable = !hasBeenResponded && requestIsActive && updateEnabledForList;

  return (
    <form id="interest-form" onSubmit={props.onSubmit}>
      <div className="legacy-bs-override">
        <Form
          formData={props.formData}
          handleChangeHousehold={props.onChangeHousehold}
          validationSchema={props.schema}
        />
      </div>
      <div
        style={{
          borderTop: "1px solid #ddd",
          display: "flex",
          justifyContent: "center",
          padding: 10,
          background: "white",
          position: "sticky",
          bottom: 0,
          zIndex: 1,
        }}
      >
        <Button
          size="L"
          color="secondary"
          marginRight
          onClick={props.onCancel}
        >
          Cancel
        </Button>

        {isKeepOnListAvailable ? (
          <DropDownButton
            type="submit"
            size="L"
            color="primary"
            disabled={props.isSending}
            currentOption={props.submitBtnIndex}
            onOptionClick={(i) => props.setSubmitBtnIndex(i)}
            options={["Update and keep on list", "Update"]}
          />
        ) : (
          <Button type="submit" size="L" color="primary" disabled={props.isSending}>
            Update
          </Button>
        )}
      </div>
    </form>
  );
};

export default InterestUpdateContent;
